import getStyles from './getStyles';
export default function isScrollable(element) {
  var excludeStatic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var includeHidden = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var styles = getStyles(element);
  var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

  if (styles == null) {
    return false;
  }

  if (excludeStatic && styles.position === 'static') {
    return false;
  }

  var testString = [styles.overflow, styles.overflowX, styles.overflowY].filter(Boolean).join('');
  return overflowRegex.test(testString);
}
//# sourceMappingURL=isScrollable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/fraud/~/@flowio/browser-helpers/dist/esm/isScrollable.js
// module id = 310
// module chunks = 0 1